import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "lockdesigner-panel-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/",
    class: "lockdesigner-logo-link",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/ResourcePackages/BaldwinHardware/assets/dist/images/logos/baldwinlogowhite.svg?version=1",
      alt: "Baldwin Logo",
      height: "26",
      width: "140"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "|"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/lock-designer",
    class: "lockdesigner-logo-text"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "lock-text" }, "LOCK DESIGNER")
  ])
], -1 /* HOISTED */)
const _hoisted_3 = { class: "lockdesigner-panel-header__home-button" }
const _hoisted_4 = { href: "/lock-designer" }

import { computed, defineComponent } from 'vue';
import Cta from 'Vue/components/lockDesigner/components/shared/Cta.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  props: {
    backToRoute: {
        type: String,
        default: null,
    },
},
  emits: ['update-route-back'],
  setup(__props, { emit }) {

const props = __props


const store = useStore();
const router = useRouter();

defineComponent({
    name: 'LockDesignerHeader',
});


// const restart = async () => {
//     window.location.href = '/lock-designer';
// };

const backVisible = computed(() => !!props.backToRoute);

function goBack() {
    emit('update-route-back', props.backToRoute);
}

return (_ctx, _cache) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(backVisible))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "lockdesigner-panel-header__back-button",
          onClick: goBack
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fass', 'arrow-left'] })
        ]))
      : _createCommentVNode("v-if", true),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", _hoisted_4, [
        _createVNode(_component_font_awesome_icon, { icon: ['fasr', 'house'] })
      ])
    ])
  ]))
}
}

}